import React from "react";
import { Link } from "react-router-dom";
import ProjectsSection from "../../components/ProjectsSection";
import Testimonials from "../../components/Testimonials";

const Design = () => {

  // ✅ UI/UX PROJECTS (FIGMA + REAL PRODUCTS YOU DESIGNED)
  const projects = [
    {
      title: "Connect App (Figma Case Study)",
      desc: "A mobile app UI/UX case study focused on seamless user interaction, onboarding experience, and intuitive navigation.",
      link: "https://www.figma.com/proto/Pj15wIMJDWnuCABUilOR2p/connect-app?node-id=2110-21",
    },

    {
      title: "Shared Solutions Website",
      desc: "Designed a clean and professional UI focused on trust, clarity, and business conversion.",
      link: "https://sharedsolutions.online",
    },

    {
      title: "Restaurant Solutions Platform",
      desc: "User-centered interface designed for restaurant owners to manage operations efficiently.",
      link: "https://www.sharedrestaurantsolutions.com",
    },

    {
      title: "Kostastina Brand Website",
      desc: "Luxury-inspired UI design with strong visual hierarchy and premium feel.",
      link: "https://kostastina.com",
    },

    {
      title: "TheLogicWaves Website",
      desc: "Modern agency UI/UX focused on storytelling, conversion, and brand positioning.",
      link: "https://www.thelogicwaves.com",
    },
  ];

  // ✅ UI/UX TESTIMONIALS (DESIGN-FOCUSED)
  const testimonials = [
    {
      name: "Sarah Ahmed",
      role: "Product Manager",
      feedback:
        "The UI/UX was incredibly intuitive and beautifully designed. It improved our user engagement significantly.",
    },
    {
      name: "Usman Tariq",
      role: "Entrepreneur",
      feedback:
        "They didn’t just design screens — they designed a complete user experience.",
    },
    {
      name: "Ali Khan",
      role: "Startup Founder",
      feedback:
        "From wireframes to final UI, everything was clean, strategic, and user-focused.",
    },
  ];

  return (
    <div className="text-white bg-black overflow-hidden">

      {/* HERO */}
      <section className="relative min-h-screen flex items-center justify-center text-center px-6">
        <div className="absolute w-[500px] h-[500px] bg-pink-600/30 blur-[120px] rounded-full top-20 left-1/2 -translate-x-1/2"></div>

        <div className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-extrabold">
            We Design <span className="text-pink-400">User Experiences</span>
          </h1>

          <p className="mt-6 text-gray-300 text-lg max-w-2xl mx-auto">
            We craft intuitive, beautiful, and conversion-focused interfaces that users love.
          </p>

          <div className="mt-10 flex gap-4 justify-center flex-wrap">
            <Link to="/contact" className="px-8 py-4 bg-pink-500 rounded-full hover:scale-105 transition">
              Start Design Project
            </Link>

            <a
              href="https://calendly.com/thelogicwaves/30min"
              target="_blank"
              rel="noreferrer"
              className="px-8 py-4 border rounded-full hover:bg-white/10 transition"
            >
              Book a Call
            </a>
          </div>
        </div>
      </section>

      {/* PROCESS */}
      <section className="py-24 text-center bg-[#0b1a35]">
        <h2 className="text-4xl font-bold mb-12">Our Design Process</h2>

        <div className="grid md:grid-cols-4 gap-8 max-w-5xl mx-auto">
          {["Research", "Wireframe", "UI Design", "Prototype"].map((step, i) => (
            <div key={i}>
              <div className="text-pink-400 text-2xl font-bold">{i + 1}</div>
              <p className="text-gray-300 mt-2">{step}</p>
            </div>
          ))}
        </div>
      </section>

      {/* PROJECTS (NOW UNIQUE) */}
      <ProjectsSection projects={projects} />

      {/* TESTIMONIALS (NOW UNIQUE) */}
      <Testimonials testimonials={testimonials} />

      {/* CTA */}
      <section className="py-28 text-center bg-gradient-to-r from-pink-500 to-purple-500 px-6">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Let’s Design Something Amazing
        </h2>

        <p className="text-gray-200 mb-8">
          Great design is not just how it looks — it’s how it works.
        </p>

        <Link to="/contact" className="bg-black px-6 py-3 rounded-full hover:scale-105 transition">
          Contact Us
        </Link>
      </section>

    </div>
  );
};

export default Design;